import { ChatType } from '@/types/chat';

export const sortChannels = (channels: ChatType[]) =>
  [...channels].sort((a, b) => {
    const aHasUnread = a.unreadCount > 0 ? 1 : 0;
    const bHasUnread = b.unreadCount > 0 ? 1 : 0;

    if (aHasUnread !== bHasUnread) {
      return bHasUnread - aHasUnread;
    }

    const aTime = new Date(a.lastMessage?.createdAt ?? 0).getTime();
    const bTime = new Date(b.lastMessage?.createdAt ?? 0).getTime();
    return bTime - aTime;
  });
